export default (api) => ({
  getAll () {
    return api.get('/users/')
  },
  create ({ username, role, password, confirmPassword }) {
    return api
      .post(
        '/users/',
        { username, role, password, confirmPassword }
      )
  },
  update (id, user) {
    return api.put(`/users/${id}`, user)
  },
  delete (id) {
    return api.delete(`/users/${id}`)
  }
})
